const components = [
    'autoNav',
    'tabs',
    'svg',
    'uedit',
    'filter',
    ['pagination', ''],
    ['uploader', 'img', 'pdf', 'video', 'click'],
];

/**
 * 加载自定义组件函数
 * @param {Vue} vue 需要传入Vue作为参数，自身没有导入Vue
 */
export function loadCustomComponents(vue) {
    loadSync(vue);

    for (let key of components) {
        if (key instanceof Array) {
            const pre = key.shift();

            vue.component(`${pre}-core`, () => import(`./${pre}/core.vue`))
            for (let ui of key) {
                vue.component(`${pre}-ui${ui && ('-' + ui)}`, () => import(`./${pre}/ui${ui && ('-' + ui)}`))
            }
        }
        else {
            vue.component(`c-${key}`, () => import(`./${key}.vue`));
        }
    }
}

import tableCore from './table/core.vue';
import tableDefiner from './table/tableDefiner.vue';
import colDefiner from './table/colDefiner.vue';
import filterDefiner from './table/filterDefiner.vue';
import formCore from './form/core.vue';

// 同步组件在这里导入
function loadSync(vue) {
    vue.component('table-core', tableCore);
    vue.component('table-definer', tableDefiner);
    vue.component('col-definer', colDefiner);
    vue.component('filter-definer', filterDefiner);
    vue.component('form-core', formCore);
}
